var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"droite"},[(_vm.renderComponent)?_c(_vm.currentTab.name,{tag:"component",attrs:{"config":_vm.currentTab.config},on:{"reload":_vm.reload}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }